<template>
  <base-modal-bottom
    ref="modal"
    class="modal-pix-key-invalid has-text-centered"
    title="Validacão de segurança"
    :isFooter="true"
    :withClickOverlay="false"
    :btnClose="false"
  >
    <div class="margin-bottom">
      <img src="@/assets/img/padlock.png" alt="Cadeado" />
    </div>

    <div class="margin-bottom title-message">
      <p>
        <strong>Validação de titularidade</strong>
      </p>
    </div>

    <p class="subtitle-message">
      Toda chave PIX registrada no Casar.com é submetida a um processo de
      validação. Neste caso, é feita uma transferência no valor simbólico de R$
      0,01 para a chave informada.
    </p>
    <template #footer>
      <base-button-bottom
        @click.native="close"
        class="is-primary is-big"
        type="button"
      >
        Ok, entendi!
      </base-button-bottom>
    </template>
  </base-modal-bottom>
</template>

<script>
import BaseModalBottom from '@/components/BaseModalBottom.vue'
import BaseButtonBottom from '@/components/BaseButtonBottom.vue'

export default {
  components: {
    BaseModalBottom,
    BaseButtonBottom,
  },

  methods: {
    open() {
      this.$refs.modal.open()
    },
    close() {
      this.$refs.modal.close()
      this.$emit('onClose')
    },
  },
}
</script>

<style lang="scss">
.modal-pix-key-invalid {
  .title-message,
  .subtitle-message,
  strong {
    max-width: 429px;
    margin: 0 auto;
    font-size: 16px;
    color: $neutral;
  }
}
</style>
